// ============================================================
// CONTENIDO EDITABLE DEL SITIO — Adrián Cuadra
// Edita aquí fotos, vídeos, estadísticas, fuentes, fechas de
// corte, valoración de mercado y datos de contacto.
// ============================================================

export const ASSETS = {
  logoIkons:
    "https://customer-assets-jt897jd0.emergentagent.net/job_cuadra-mediocentro/artifacts/793f61800339db66_IMG_9412.png",
  hero: "https://customer-assets-jt897jd0.emergentagent.net/job_cuadra-mediocentro/artifacts/6c1a6e0a9e8613da_99E45F2D-A23A-4225-A6B1-CB752C552639.jpeg",
  portrait:
    "https://customer-assets-jt897jd0.emergentagent.net/job_cuadra-mediocentro/artifacts/ea06623b61a4afa4_92A031C7-E878-4750-87E9-0EDD5E1AB759.jpeg",
  actionNight:
    "https://customer-assets-jt897jd0.emergentagent.net/job_cuadra-mediocentro/artifacts/0cdab26fbc1d41de_7A0358DE-C195-4AA3-9D6F-92297F6AE907.webp",
  celebration:
    "https://customer-assets-jt897jd0.emergentagent.net/job_cuadra-mediocentro/artifacts/e5a50193454ae762_CA2FE702-68E2-4815-AF6F-A0634EA80215.jpeg",
};

export const SOURCES = {
  sofascore: "https://www.sofascore.com/es/football/player/adrian-cuadra/824166",
  transfermarkt: "https://www.transfermarkt.es/adrian-cuadra/profil/spieler/413189",
};

// Vídeos: añade más entradas copiando este bloque.
export const VIDEOS = [
  {
    embedUrl: "https://player.vimeo.com/video/1205959936?h=cd43e2b6d8&app_id=122963",
    watchUrl: "https://vimeo.com/1205959936/cd43e2b6d8",
    title: "Adrián Cuadra — Video Highlight",
    duration: "6:11",
  },
];

// Datos editables clave
export const EDITABLE = {
  statsCheckedAt: "24.10.2026", // última consulta de fuentes externas
  marketValue: "€225.000",
  marketProvider: "Transfermarkt",
  marketCheckedAt: "octubre de 2026",
  contactEmail: "merinovidangossy@gmail.com", // dato público de IKONS — confirmar/reemplazar
  contactPhone: "+34 665 497 561", // dato público de IKONS — confirmar/reemplazar
  contactPhoneHref: "tel:+34665497561",
};

export const CONTENT = {
  es: {
    nav: {
      perfil: "Perfil",
      estadisticas: "Estadísticas",
      trayectoria: "Trayectoria",
      videos: "Vídeos",
      galeria: "Galería",
      mercado: "Mercado",
      contacto: "Contacto",
    },
    hero: {
      eyebrow: "IKONS · Perfil oficial del jugador",
      line1: "ADRIÁN",
      line2: "CUADRA",
      subtitle: "Mediocentro · Deportes Antofagasta · Chile",
      phrase:
        "Mediocampista con visión para conectar el juego y capacidad para transformar la posesión en peligro.",
      ctaProfile: "Perfil",
      ctaStats: "Estadísticas",
      ctaVideos: "Vídeos",
      contract: "Contrato hasta el 31.12.2026 · Deportes Antofagasta",
    },
    marquee: [
      "Mediocentro",
      "Visión de juego",
      "Pases peligrosos",
      "Asistencias",
      "Progresión",
      "Deportes Antofagasta",
    ],
    perfil: {
      number: "01",
      title: "Perfil",
      photoTag: "Foto · Retrato",
      intro:
        "Mediocentro chileno con experiencia en el fútbol profesional de Chile. Su juego se apoya en la lectura de espacios, la conexión con los atacantes y la producción ofensiva desde la medular.",
      data: [
        { label: "Edad", value: "29 años" },
        { label: "Nacimiento", value: "23.10.1997 · Valparaíso, Chile" },
        { label: "Estatura", value: "1,71 m", src: "Fuente: Transfermarkt" },
        { label: "Pie hábil", value: "Derecho" },
        { label: "Posición", value: "Mediocentro · también pivote" },
        { label: "Club", value: "Deportes Antofagasta" },
        { label: "Dorsal", value: "20" },
        { label: "Representación", value: "IKONS" },
      ],
      traitsTitle: "Perfil de juego",
      traits: [
        {
          tag: "Observación · análisis audiovisual",
          title: "Conexión",
          text: "Ofrece líneas de pase constantes y conecta con los atacantes entre líneas.",
        },
        {
          tag: "Observación + dato",
          title: "Progresión",
          text: "Progresa mediante pases que superan líneas de presión: 56 pases peligrosos en Liga de Ascenso 2026.",
        },
        {
          tag: "Observación · análisis audiovisual",
          title: "Zonas interiores",
          text: "Genera situaciones de peligro recibiendo entre el mediocampo y el ataque rival.",
        },
        {
          tag: "Dato · SofaScore",
          title: "Fortalezas registradas",
          text: "SofaScore identifica como fortalezas de su perfil la creación de juego y los pases largos.",
        },
      ],
      note: "Las observaciones proceden del análisis del material audiovisual disponible; los datos, de las fuentes citadas en cada bloque.",
    },
    stats: {
      number: "02",
      title: "Estadísticas 2026",
      cards: [
        { value: "28", label: "Partidos · 28 de titular", sub: "Liga de Ascenso 2026" },
        { value: "2", label: "Asistencias", sub: "Liga de Ascenso 2026" },
        { value: "56", label: "Pases peligrosos", sub: "7.º del torneo · corte analizado" },
        { value: "3", label: "Asistencias", sub: "Copa Chile 2026" },
      ],
      tabs: { liga: "Liga de Ascenso", copa: "Copa Chile" },
      tableCols: ["Competición", "PJ", "Tit.", "Min", "Goles", "Asist.", "TA–TR", "Pases peligrosos"],
      liga: {
        row: ["Liga de Ascenso 2026", "28", "28", "2.342", "1", "2", "3–0", "56"],
      },
      copa: {
        row: ["Copa Chile 2026", "6", "6", "486", "0", "3", "1–0", "—"],
        footnote: "Fuente del registro de partidos: SofaScore · Consulta: 12.10.2026",
      },
      totalRow: ["Total 2026", "34", "34", "2.828", "1", "5", "4–0", "56*"],
      totalFootnote: "*Pases peligrosos registrados solo en Liga de Ascenso.",
      source: "Fuente: Transfermarkt",
      cutoff: "Consulta: 24.10.2026",
      recentTitle: "Registro reciente · Copa Chile 2026",
      recentCols: ["Fecha", "Partido", "Asist.", "Valoración"],
      recent: [
        { date: "07.10.26", match: "Antofagasta 2–0 U. de Chile", assist: "1", rating: "7.1" },
        { date: "27.09.26", match: "Antofagasta 4–1 Deportes Iquique", assist: "1", rating: "8.2" },
        { date: "23.09.26", match: "Deportes Iquique 1–1 Antofagasta", assist: "1", rating: "6.9" },
      ],
      disclaimer:
        "Cada competición se muestra en su propia pestaña; la fila Total 2026 las suma a modo de referencia anual. Las cifras pueden variar tras cada jornada.",
    },
    trayectoria: {
      number: "03",
      title: "Trayectoria",
      items: [
        {
          period: "2015",
          club: "Santiago Wanderers",
          text: "Ascenso al primer equipo desde Santiago Wanderers U20 (30.06.2015).",
          source: "SofaScore",
        },
        {
          period: "2015 – 2019",
          club: "Santiago Wanderers",
          text: "Primera etapa profesional en el club de Valparaíso, su ciudad natal. En 2017 disputó el Sudamericano Sub-20 con Chile (3 partidos).",
          source: "Tribuna.com",
        },
        {
          period: "2020",
          club: "Deportes Antofagasta",
          text: "Fichaje por Deportes Antofagasta (26.10.2020).",
          source: "Transfermarkt",
        },
        {
          period: "2020 – hoy",
          club: "Deportes Antofagasta",
          text: "Mediocentro del plantel profesional, dorsal 20. Contrato vigente hasta el 31.12.2026.",
        },
      ],
      careerTitle: "Carrera en clubes",
      careerCols: ["Club", "PJ", "Goles", "Asist."],
      careerRows: [
        ["Santiago Wanderers · 2015–2019", "112", "3", "1"],
        ["Deportes Antofagasta · 2020–hoy", "152", "9", "6"],
        ["Total carrera", "264", "12", "7"],
      ],
      careerSource: "Fuente: Tribuna.com · Consulta: 12.10.2026",
      careerNote:
        "Las estadísticas de carrera se presentan separadas de las cifras de 2026 y pueden variar tras cada jornada.",
    },
    videos: {
      number: "04",
      title: "Vídeos",
      featured: "Video destacado",
      open: "Abrir en Vimeo",
      note: "Material exclusivo: se reproduce únicamente dentro de este sitio.",
      more: "Sección editable: se pueden añadir más vídeos del dossier.",
    },
    galeria: {
      number: "05",
      title: "Galería",
      note: "Material de partido. Los pies de foto se añadirán cuando se confirmen rival, competición y fecha.",
      alts: [
        "Adrián Cuadra conduce el balón en un partido con Deportes Antofagasta",
        "Adrián Cuadra celebra durante un partido con Deportes Antofagasta",
        "Adrián Cuadra disputa el balón en un partido nocturno",
        "Retrato de Adrián Cuadra en partido",
      ],
    },
    mercado: {
      number: "06",
      title: "Valoración y mercado",
      valueLabel: "Estimación de valor de mercado",
      sourceLine: "Fuente: Transfermarkt · Consulta: octubre de 2026",
      disclaimer:
        "Estimación publicada por el proveedor. No representa una oferta, una cláusula ni el precio de un traspaso.",
      sourceCta: "Ver fuente en Transfermarkt",
      altNote: "SofaScore publica una cifra distinta; este sitio muestra un solo proveedor a la vez.",
      contractTitle: "Situación contractual",
      contractLines: [
        "Contrato hasta el 31.12.2026",
        "Deportes Antofagasta",
        "Bajo contrato durante toda la temporada 2026",
      ],
    },
    contacto: {
      number: "07",
      title: "Contacto profesional",
      intro:
        "Consultas de clubes, directores deportivos, entrenadores y scouts. Representación: IKONS.",
      agentName: "Edgar Merino Vidangossy",
      agentRole: "Agente FIFA · IKONS",
      directCta: "Contacto directo IKONS",
      form: {
        name: "Nombre *",
        club: "Club",
        role: "Cargo",
        email: "Correo *",
        message: "Mensaje *",
        submit: "Enviar mensaje",
        sending: "Enviando…",
        ok: "Mensaje enviado. IKONS responderá a la brevedad.",
        error: "No se pudo enviar. Inténtalo de nuevo o escribe directamente a IKONS.",
      },
    },
    footer: {
      sources: "Fuentes de referencia",
      rights: "© 2026 Adrián Cuadra · Representación: IKONS",
      tag: "Sitio oficial de presentación",
    },
  },
  en: {
    nav: {
      perfil: "Profile",
      estadisticas: "Stats",
      trayectoria: "Career",
      videos: "Videos",
      galeria: "Gallery",
      mercado: "Market",
      contacto: "Contact",
    },
    hero: {
      eyebrow: "IKONS · Official player profile",
      line1: "ADRIÁN",
      line2: "CUADRA",
      subtitle: "Central Midfielder · Deportes Antofagasta · Chile",
      phrase:
        "A midfielder with the vision to connect play and the ability to turn possession into danger.",
      ctaProfile: "Profile",
      ctaStats: "Stats",
      ctaVideos: "Videos",
      contract: "Contract until 31.12.2026 · Deportes Antofagasta",
    },
    marquee: [
      "Central Midfielder",
      "Game vision",
      "Dangerous passes",
      "Assists",
      "Progression",
      "Deportes Antofagasta",
    ],
    perfil: {
      number: "01",
      title: "Profile",
      photoTag: "Photo · Portrait",
      intro:
        "Chilean central midfielder with experience in Chilean professional football. His game is built on reading space, connecting with attackers and offensive output from midfield.",
      data: [
        { label: "Age", value: "29 years" },
        { label: "Born", value: "23.10.1997 · Valparaíso, Chile" },
        { label: "Height", value: "1.71 m", src: "Source: Transfermarkt" },
        { label: "Preferred foot", value: "Right" },
        { label: "Position", value: "Central midfield · also holding midfield" },
        { label: "Club", value: "Deportes Antofagasta" },
        { label: "Shirt number", value: "20" },
        { label: "Representation", value: "IKONS" },
      ],
      traitsTitle: "Playing profile",
      traits: [
        {
          tag: "Observation · video analysis",
          title: "Connection",
          text: "Constantly offers passing lanes and links up with attackers between the lines.",
        },
        {
          tag: "Observation + data",
          title: "Progression",
          text: "Progresses play with line-breaking passes: 56 dangerous passes in Liga de Ascenso 2026.",
        },
        {
          tag: "Observation · video analysis",
          title: "Half-spaces",
          text: "Creates dangerous situations receiving between midfield and the opposition attack.",
        },
        {
          tag: "Data · SofaScore",
          title: "Recorded strengths",
          text: "SofaScore lists playmaking and long passing as strengths of his profile.",
        },
      ],
      note: "Observations come from analysis of the available video material; data comes from the sources cited in each block.",
    },
    stats: {
      number: "02",
      title: "2026 Stats",
      cards: [
        { value: "28", label: "Appearances · 28 starts", sub: "Liga de Ascenso 2026" },
        { value: "2", label: "Assists", sub: "Liga de Ascenso 2026" },
        { value: "56", label: "Dangerous passes", sub: "7th in the league · analysed cutoff" },
        { value: "3", label: "Assists", sub: "Copa Chile 2026" },
      ],
      tabs: { liga: "Liga de Ascenso", copa: "Copa Chile" },
      tableCols: ["Competition", "Apps", "Starts", "Min", "Goals", "Assists", "YC–RC", "Dangerous passes"],
      liga: {
        row: ["Liga de Ascenso 2026", "28", "28", "2,342", "1", "2", "3–0", "56"],
      },
      copa: {
        row: ["Copa Chile 2026", "6", "6", "486", "0", "3", "1–0", "—"],
        footnote: "Match record source: SofaScore · Checked: 12.10.2026",
      },
      totalRow: ["Total 2026", "34", "34", "2,828", "1", "5", "4–0", "56*"],
      totalFootnote: "*Dangerous passes recorded in Liga de Ascenso only.",
      source: "Source: Transfermarkt",
      cutoff: "Checked: 24.10.2026",
      recentTitle: "Recent record · Copa Chile 2026",
      recentCols: ["Date", "Match", "Assists", "Rating"],
      recent: [
        { date: "07.10.26", match: "Antofagasta 2–0 U. de Chile", assist: "1", rating: "7.1" },
        { date: "27.09.26", match: "Antofagasta 4–1 Deportes Iquique", assist: "1", rating: "8.2" },
        { date: "23.09.26", match: "Deportes Iquique 1–1 Antofagasta", assist: "1", rating: "6.9" },
      ],
      disclaimer:
        "Each competition is shown in its own tab; the Total 2026 row sums both as an annual reference. Figures may change after each matchday.",
    },
    trayectoria: {
      number: "03",
      title: "Career",
      items: [
        {
          period: "2015",
          club: "Santiago Wanderers",
          text: "Promoted to the first team from Santiago Wanderers U20 (30.06.2015).",
          source: "SofaScore",
        },
        {
          period: "2015 – 2019",
          club: "Santiago Wanderers",
          text: "First professional spell at the club of his hometown, Valparaíso. In 2017 he played the South American U-20 Championship with Chile (3 matches).",
          source: "Tribuna.com",
        },
        {
          period: "2020",
          club: "Deportes Antofagasta",
          text: "Signs for Deportes Antofagasta (26.10.2020).",
          source: "Transfermarkt",
        },
        {
          period: "2020 – present",
          club: "Deportes Antofagasta",
          text: "Central midfielder in the first-team squad, shirt number 20. Contract valid until 31.12.2026.",
        },
      ],
      careerTitle: "Club career",
      careerCols: ["Club", "Apps", "Goals", "Assists"],
      careerRows: [
        ["Santiago Wanderers · 2015–2019", "112", "3", "1"],
        ["Deportes Antofagasta · 2020–present", "152", "9", "6"],
        ["Career total", "264", "12", "7"],
      ],
      careerSource: "Source: Tribuna.com · Checked: 12.10.2026",
      careerNote:
        "Career statistics are shown separately from 2026 figures and may change after each matchday.",
    },
    videos: {
      number: "04",
      title: "Videos",
      featured: "Featured video",
      open: "Watch on Vimeo",
      note: "Exclusive material: it plays only on this site.",
      more: "Editable section: more videos from the dossier can be added.",
    },
    galeria: {
      number: "05",
      title: "Gallery",
      note: "Match footage. Captions will be added once opponent, competition and date are confirmed.",
      alts: [
        "Adrián Cuadra drives the ball during a match for Deportes Antofagasta",
        "Adrián Cuadra celebrates during a match for Deportes Antofagasta",
        "Adrián Cuadra challenges for the ball in a night match",
        "Portrait of Adrián Cuadra during a match",
      ],
    },
    mercado: {
      number: "06",
      title: "Market valuation",
      valueLabel: "Estimated market value",
      sourceLine: "Source: Transfermarkt · Checked: October 2026",
      disclaimer:
        "Estimate published by the provider. It does not represent an offer, a release clause or a transfer fee.",
      sourceCta: "View source on Transfermarkt",
      altNote: "SofaScore publishes a different figure; this site shows a single provider at a time.",
      contractTitle: "Contract status",
      contractLines: [
        "Contract until 31.12.2026",
        "Deportes Antofagasta",
        "Under contract for the entire 2026 season",
      ],
    },
    contacto: {
      number: "07",
      title: "Professional contact",
      intro: "Enquiries from clubs, sporting directors, coaches and scouts. Representation: IKONS.",
      agentName: "Edgar Merino Vidangossy",
      agentRole: "FIFA Agent · IKONS",
      directCta: "Direct IKONS contact",
      form: {
        name: "Name *",
        club: "Club",
        role: "Position",
        email: "Email *",
        message: "Message *",
        submit: "Send message",
        sending: "Sending…",
        ok: "Message sent. IKONS will reply shortly.",
        error: "Could not send. Please try again or write to IKONS directly.",
      },
    },
    footer: {
      sources: "Reference sources",
      rights: "© 2026 Adrián Cuadra · Representation: IKONS",
      tag: "Official presentation site",
    },
  },
};
